import iconSearch from 'assets/image/icons/svg/search-icon-grey.svg'
import TextFieldCustom from 'components/atoms/TextFieldCustom'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Param } from 'shared/search-adapters'

export function Search({ isModal = false }: { isModal?: boolean }) {
	const [params, setParams] = useSearchParams()
	const searchParam = isModal ? Param.ModalSearchQuery : Param.SearchQuery
	const currentUrlValue = params.get(searchParam) ?? ''
	const [search, setSearch] = useState(() => currentUrlValue)

	function onSetKeywords() {
		if (search !== currentUrlValue) {
			setParams(prev => {
				prev.set(searchParam, search)
				prev.delete(isModal ? Param.ModalSkip : Param.Skip)
				return prev
			})
		}
	}

	useEffect(() => setSearch(currentUrlValue), [currentUrlValue])

	return (
		<TextFieldCustom
			endAdornment={
				<img
					alt='search'
					className='icon-search'
					onClick={onSetKeywords}
					src={iconSearch}
				/>
			}
			onBlur={onSetKeywords}
			onChange={e => setSearch(e.target.value)}
			onEnter={onSetKeywords}
			placeholder={'Search'}
			value={search}
		/>
	)
}
